
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

if (process.client) {
  gsap.registerPlugin(ScrollTrigger)
}
export default {
  props: {
    faq: { type: Object, required: true, default: () => {} }
  },
  data () {
    return {
      animation: null,
      show: false
    }
  },
  mounted () {
    const _this = this
    gsap.utils.toArray(['.text p strong', '.text ul li strong']).forEach(function (elem) {
      _this.animation = gsap.timeline({
        scrollTrigger: {
          trigger: elem,
          start: 'top 70%',
          end: 'bottom 10%',
          // markers: true,
          toggleActions: 'restart pause resume none',
          onLeaveBack: self => self.disable()
        }
      })
      _this.animation.to(elem, 0.8, { backgroundSize: '100% 40%' })
    })
  },
  beforeDestroy () {
    ScrollTrigger.getAll().forEach(t => t.kill())
  },
  methods: {
    showFaq () {
      this.show = !this.show
      const panel = this.$refs.panel
      const accordion = this.$refs.accordion
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
        panel.style.backgroundColor = '#fff'
        accordion.style.backgroundColor = '#fff'
      } else {
        panel.style.maxHeight = '5000px'
        accordion.style.backgroundColor = '#f5f5f5'
        panel.style.backgroundColor = '#f5f5f5'
      }
    }
  }
}
